module.exports = __webpack_public_path__ + "static/img/11.a6d49a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/eng/11.png
// module id = sLB5
// module chunks = 0